import { SEARCH_VEHICLE_NOT_COVERED_IN_COUNTRY } from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { setVehicleDetail } from 'domains/catalog/Catalog.store';
import { WsResponse } from 'domains/webSockets/WebSocket.types';
import { notifyTop } from 'UI/Notification/notification';
import { AppTranslation, NOT_FOUND, sagaGuard } from 'utils';

export function* handleVehicleNotCoveredInCountrySaga(action: WsResponse<{ requestId: string }>): SagaIterator {
  const requestId = action.payload?.requestId;

  if (requestId) {
    // Put the search into its error state so the search component shows the failure and the
    // catalog page stops the endless spinner (renders the "not found" state instead of Loader).
    // NOT_FOUND is used on purpose: it does not reveal that the vehicle exists in another country.
    yield put(setVehicleDetail({ requestId, vehicle: undefined, status: NOT_FOUND }));
  }

  yield call(
    notifyTop,
    'error',
    AppTranslation.t('catalog.search.vehicle_not_covered.title', 'Vehicle not covered in your country') as string,
    AppTranslation.t(
      'catalog.search.vehicle_not_covered.message',
      "This vehicle's data seems to be unavailable in your country's catalog. Please identify another vehicle.",
    ) as string,
  );
}

export function* vehicleNotCoveredInCountrySaga(): SagaIterator {
  yield takeEvery(SEARCH_VEHICLE_NOT_COVERED_IN_COUNTRY, sagaGuard(handleVehicleNotCoveredInCountrySaga));
}
